export default {
  clearFilters({ commit, state }) {
    commit("setCategorieFilter", {})
    commit("setOfferFilter", {})
    commit("setCampaignFilter", {})
    commit("setSvaFilter", {})
  },
  removeFilterKey({ commit }, { filterType, key }) {
    commit("removeFilterKey", { filterType, key })
  }
}
